module.exports = __webpack_public_path__ + "img/PORT09.3488da61.jpg";